import { jsonldBusinessFunction } from './JsonldStore';

export const updateJsonldBusinessFunction = (value) => jsonldBusinessFunction.update((oldValue) => value);
